<template>
  <el-dialog
    v-model="dialogVisible"
    title="一车一档"
    width="80%"
    @close="closeDialog"
  >
    <div class="plate">
      <h-car-plate :type="itemInfo.plateColor" title="">{{
        itemInfo.plateNo
      }}</h-car-plate>
    </div>
    <div class="carArchivesDialog" v-loading="loading">
      <el-card class="tree-card" :body-style="treeCard">
        <div class="Title">车辆信息</div>
        <el-row>
          <el-col class="leftTitle" :span="12"
            >车主姓名:&nbsp;&nbsp; {{}}</el-col
          >
        </el-row>
        <el-row>
          <el-col class="leftTitle" :span="12"
            >车辆类型:&nbsp;&nbsp;{{}}</el-col
          >
        </el-row>
        <el-row>
          <el-col class="leftTitle" :span="12"
            >车辆颜色:&nbsp;&nbsp;{{}}</el-col
          >
        </el-row>
        <el-row>
          <el-col class="leftTitle" :span="12"
            >车辆品牌:&nbsp;&nbsp;{{}}</el-col
          >
        </el-row>
        <el-row>
          <el-col class="leftTitle" :span="12"
            >车牌类型:&nbsp;&nbsp;{{}}</el-col
          >
        </el-row>
        <el-row>
          <el-col class="leftTitle" :span="12"
            >车牌型号:&nbsp;&nbsp;{{}}</el-col
          >
        </el-row>
        <div class="Title">车辆标签</div>
        <el-button type="warning">{{ cartags ? cartags : "暂无" }} </el-button>
      </el-card>
      <el-card class="tabs-card" v-if="!mapActive">
        <div
          class="tabsCard-content"
          v-for="(item, index) in carLabel"
          :key="index"
          @click="labelClick(item)"
        >
          <div class="label-title">
            <span>{{ item.name }}</span>
            <span style="color: red">{{ item.total }}</span>
          </div>
          <template v-for="(it, ind) in item.info" :key="ind">
            <div class="label-content" v-if="item.info">
              <div
                v-if="ind < 1 && item.name == '车辆轨迹'"
                class="label-content-item"
              >
                <div class="item-name">
                  {{ it.deviceName }}
                  <div style="margin-top: 16px">
                    {{
                      moment(parseInt(it.passTime)).format("YYYY-MM-DD hh:mm")
                    }}
                  </div>
                </div>
              </div>
              <div
                v-if="ind <= 3 && item.name == '落脚点'"
                class="label-content-item"
              >
                <span class="item-name">{{ it.tollgateName }}</span>
                <span>{{ it.count }}</span>
              </div>
              <div
                v-if="item.info != null && ind <= 3 && item.name == '活跃卡口'"
                class="label-content-item"
              >
                <span>{{ it.tollgateName }}</span>
                <span>{{ it.count }}</span>
              </div>
              <div
                v-if="ind <= 3 && item.name == '活跃区域'"
                class="label-content-item"
              >
                <span>{{ it.areaName }}</span>
                <span>{{ it.count }}</span>
              </div>
            </div>
          </template>
        </div>
      </el-card>
      <div class="mapInfo" v-else>
        <div class="title">
          <h-icon icon="icon-guanbi2" @click="closeMap" font-size="24"></h-icon>
        </div>
        <div v-if="labelActiveName == '车辆轨迹'" class="carArchivesTable">
          <h-table
            ref="tableRef"
            v-model:columns="columns"
            :params="tableParams"
            highlight-current-row
            :method="handleHistorytrack"
            layout="total, pager"
          >
            <template #picUrl="{ row }">
              <div class="table-role" @click="clickTable(row)">
                <img
                  v-if="row.picUrl"
                  style="width: 100%; height: 68px; cursor: pointer"
                  :src="row.picUrl"
                />
                <img v-else src="~@/assets/images/moren.png" />
              </div>
            </template>
            <template #passTime="{ row }">
              <div class="table-role">
                {{
                  moment(parseInt(row.passTime)).format("YYYY-MM-DD HH:mm:ss")
                }}
              </div>
            </template>
          </h-table>
        </div>
        <MyMap ref="mapRef" />
      </div>
      <h-big-picture
        :pictureUrl="pictureUrl"
        v-model:visible="bigPictureVisible"
      ></h-big-picture>
    </div>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  nextTick,
  watchEffect,
  onMounted,
} from "vue";
import MyMap from "@/components/map/MyMap.vue";
import {
  archivesInfo,
  archivesTags,
  historytrack,
} from "@/api/publicSecurityResearch/keyKehicles.js";
import { ElMessageBox, ElMessage } from "element-plus";
import util from "@util/js";
import moment from "moment";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "carArchivesDialog",
  components: { MyMap },
  props: {
    firstCityDetail: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // tableParams: {
    //   type: Object,
    //   default: () => {
    //     return {};
    //   },
    // },
    // 展示弹窗
    visible: {
      type: Boolean,
      default: false,
    },
    itemInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props, { emit }) {
    const router = useRouter();
    const data = reactive({
      loading: false,
      tableData: null,
      dialogVisible: false,
      treeCard: {
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      },
      showDeckFirst: false,
      showDeckSecond: false,
      currentRow: null,
      dataInfo: null,
      carLabel: [
        { name: "车辆轨迹", info: null, total: 0 },
        { name: "落脚点", info: null, total: 0 },
        { name: "活跃卡口", info: null, total: 0 },
        { name: "活跃区域", info: null, total: 0 },
      ],
      cartags: "",
      mapActive: false,
      labelActiveName: "",
      columns: [
        { type: "selection", show: false },
        {
          label: "抓拍图",
          slot: "picUrl",
        },
        {
          label: "抓拍地点",
          prop: "deviceName",
        },
        {
          label: "抓拍时间",
          slot: "passTime",
        },
      ],
      tableParams: {
        plateNo: "",
        plateColor: "",
      },

      pictureUrl: null,
      bigPictureVisible: false,
      //沪C0YC56
    });
    const tableRef = ref();
    const refData = toRefs(data);
    const mapRef = ref();

    //使用wache监听不报红
    watchEffect(() => {
      data.dialogVisible = props.visible;
      data.tableParams.plateNo = props.itemInfo.plateNo;
      data.tableParams.plateColor = props.itemInfo.plateColor;
    });
    const closeDialog = () => {
      emit("update:visible", false);
    };
    const labelClick = (item) => {
      data.mapActive = true;
      data.labelActiveName = item.name;
      if (item.name == "车辆轨迹") {
        refresh();
        return;
      }
      setTimeout(() => {
        pointInfoArray(item.info);
      }, 300);
    };
    const closeMap = () => {
      data.mapActive = false;
    };

    //获取一车一档详情
    const tollgateRecordAsync = async () => {
      data.loading = true;
      const res = await archivesInfo(data.tableParams);
      if (res.code == 0) {
        //车辆轨迹赋值
        data.carLabel[0].info =
          res.data.historyTrack && res.data.historyTrack.list;
        data.carLabel[0].total =
          res.data.historyTrack && res.data.historyTrack.totalCount;
        //落脚点赋值
        data.carLabel[1].info = res.data.residence && res.data.residence.list;
        data.carLabel[1].total =
          res.data.residence && res.data.residence.totalCount;
        //活跃卡口赋值
        data.carLabel[2].info = res.data.haunt && res.data.haunt.list;
        data.carLabel[2].total = res.data.haunt && res.data.haunt.totalCount;
        //活跃区域赋值
        data.carLabel[3].info = res.data.hauntArea && res.data.hauntArea.list;
        data.carLabel[3].total =
          res.data.hauntArea && res.data.hauntArea.totalCount;
      }
      data.carLabel = data.carLabel.filter((item) => {
        return item.info != null;
      });
      data.loading = false;
    };
    //获取车辆详情
    const archivesTagsAsync = async () => {
      const res = await archivesTags(data.tableParams);
      if (res.code == 0) {
        data.cartags = res.list[0] && res.list[0].tagName;
      }
    };
    // 添加接口中数据点位
    const pointInfoArray = (list) => {
      const array = list.filter((item, index) => {
        if (item.longitude && item.latitude) {
          return item;
        }
      });
      const newList = array.map((element, index) => {
        const pointInfo = {
          name: element.count,
          item: element,
          id: 1,
          type: 1,
          showType: 1,
          location: [],
          click: (e) => {},
        };
        pointInfo.id = index + 1;
        pointInfo.location[0] = parseFloat(element.longitude);
        pointInfo.location[1] = parseFloat(element.latitude);
        return pointInfo;
      });
      nextTick(() => {
        console.log(newList);
        mapRef.value && mapRef.value.loadMarker(newList);
      });
    };
    // 落脚点分析列表
    const handleHistorytrack = async () => {
      const res = await historytrack(data.tableParams);
      data.tableData = res.page.list;
      pointInfoArray(res.page.list);
      return res;
    };
    // 表单提交
    const refresh = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 图片点击
    const clickTable = (row) => {
      data.pictureUrl = row.picUrl;
      data.bigPictureVisible = true;
    };
    tollgateRecordAsync();
    archivesTagsAsync();

    return {
      ...refData,
      moment,
      mapRef,
      tableRef,
      handleHistorytrack,
      closeDialog,
      closeMap,
      labelClick,
      clickTable,
    };
  },
});
</script>
<style lang="scss" scoped>
.plate {
  @include flex-col-c-c;
  padding: 8px 0;
  height: 4vh;
}
.carArchivesDialog {
  width: 100%;
  height: 61vh;
  display: flex;

  .tree-card {
    height: 100%;
    width: 240px;
    @include flex-col-c-c;
    .el-row {
      margin: 8px;
    }
    .Title {
      border-left: 3px solid #5584ff;
      font-size: 14px;
      color: #333;
      font-weight: bolder;
      height: 20px;
      line-height: 20px;
      padding-left: 8px;
      margin: 15px 0;
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    :deep(.el-card__body) {
      display: flex;
      flex-direction: row !important;
      flex-wrap: wrap;
    }
    .tabsCard-content {
      width: 320px;
      height: 210px;
      display: inline-block;
      margin: 0 25px 50px 0;
      cursor: pointer;
      border-radius: 10px;
      background-color: #fff;
      box-shadow: 0 0px 6px 0 #f0f0f0;
      overflow: hidden;
      &:hover {
        transform: translate(0, -10px);
        box-shadow: 0 5px 10px 0 #f0f0f0;
        transition: box-shadow 0.5s, transform 0.5s;
        .label-title {
          background: #5584ff;
          color: #fff;
        }
      }
      .label-title {
        height: 41px;
        width: 100%;
        padding: 0 25px;
        text-align: left;
        background: rgba(21, 56, 145, 0.09);
        line-height: 41px;
        font-size: 18px;
        font-weight: 600;
        color: black;
        display: flex;
        justify-content: space-between;
        margin: 0 12px 12px 0px;
        transition: all 0.2s;
      }
      .label-content {
        margin-top: 16px;
        .label-content-item {
          display: flex;
          justify-content: space-between;
          margin: 0 12px 12px 12px;
          .item-name {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .mapInfo {
    margin-left: 10px;
    flex: 1;
    height: calc(100% - 32px);
    position: relative;
    .title {
      text-align: end;
      line-height: 32px;
      background: #5584ff;
      height: 32px;
      color: red;
      font-size: 16px;
    }
    .carArchivesTable {
      position: absolute;
      left: 0px;
      z-index: 100;
      width: 370px;
      height: 100%;
      background-color: #fff;
      /deep/.hz-table {
        height: 90%;
      }
      /deep/.el-pagination {
        width: 100%;
      }
      :deep(.MyFrame-content) {
        background-color: #fff;
      }
      :deep(.openIconFrame) {
        background-color: #fff;
      }
    }
  }
}
</style>
